import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import highlight from "highlight.js";
import highlightJavascript from "highlight.js/lib/languages/javascript";
import highlightTypescript from "highlight.js/lib/languages/typescript";
import highlightCSS from "highlight.js/lib/languages/css";
import highlightBash from "highlight.js/lib/languages/bash";
import highlightXML from "highlight.js/lib/languages/xml";
import { HighlightCodeProps } from "./PropsType";

declare const window: any;

export default function HighlightCode(props: HighlightCodeProps) {
  const {
    className,
    children,
    lang = "javascript",
    prefixCls = "bm-HighlightCode",
    showCopy,
    ...other
  } = props;
  const styleClass = classNames(prefixCls, `${prefixCls}-${lang}`, className);
  const codeClass = classNames("hljs", lang);
  const code = useRef(null);
  const setLang = (props: any) => {
    switch (props.lang) {
      case "typescript":
        highlight.registerLanguage("typescript", highlightTypescript);
        break;
      case "javascript":
        highlight.registerLanguage("javascript", highlightJavascript);
        break;
      case "xml":
        highlight.registerLanguage("xml", highlightXML);
        break;
      case "bash":
        highlight.registerLanguage("bash", highlightBash);
        break;
      case "css":
        highlight.registerLanguage("css", highlightCSS);
        break;
    }
    if (code.current) {
      highlight.highlightElement(code.current);
    }
  };

  const clearSelection = () => {
    const selection = window.getSelection();
    try {
      selection?.removeAllRanges();
    } catch (ex) {
      (document as any).body.createTextRange().select();
      (document as any).selection.empty();
    }
  };

  const onCopy = () => {
    if (code.current) {
      clearSelection();
      (code.current as HTMLElement).appendChild(document.createTextNode(""));
      const range = document.createRange();
      range.setStart(code.current, 0);
      range.setEnd((code.current as HTMLElement).lastChild as any, 0);
      window.getSelection().addRange(range);
      document.execCommand("copy");
    }
  };

  useEffect(() => {
    setLang(props);
  }, []);

  return (
    <div className={styleClass} lang={lang} {...other}>
      <pre>
        <code className={codeClass} ref={code}>
          {children}
        </code>
      </pre>
      {showCopy ? (
        <button className="bm-HighlightCode-btn" onClick={onCopy}>
          <i title="Copy" className="Icon material-icons">
            content_copy
          </i>
        </button>
      ) : null}
    </div>
  );
}
